import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ScrollView, Image, Platform, Linking, Modal } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useDispatch, useSelector } from 'react-redux';
import { loginActions } from './slices/authSlice';
import API_PATHS from './apiCalls/ApiPath';

const ProfileScreen = () => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const [modalVisible, setModalVisible] = useState(false);
  const userType = useSelector((state) => state.auth.userType);

  console.log("userType from profile", userType);

  const isAdmin = userType === 'admin' || userType === '"admin"';

  const menuItems = [
    { title: 'About Us', link: 'https://danileeshelpinghands.org/' },
    { title: 'Family', route: 'Family', disabled: isAdmin },
    { title: 'Invoices', route: 'Invoices', disabled: isAdmin },
    { title: 'My Profile', route: 'ProfilePage', disabled: isAdmin },
    { title: 'Terms & Conditions', link: `${API_PATHS.BASE_URL}${API_PATHS.TERMS_CONDITIONS}` },
  ];

  const handleLogout = async () => {
    try {
      await AsyncStorage.clear();
      dispatch(loginActions.setToken(null));
      setModalVisible(false);
    } catch (error) {
      console.error('Error clearing AsyncStorage:', error);
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.headerTitle}>Profile</Text>
        <TouchableOpacity onPress={() => navigation.navigate('Notification')}>
          <Image source={require('./assets/notification1.png')} style={styles.notificationIcon} />
        </TouchableOpacity>
      </View>

      <ScrollView contentContainerStyle={styles.menuContainer}>
        {menuItems.map((item, index) => (
          <TouchableOpacity
            key={index}
            style={[styles.menuItem, item.disabled && { opacity: 0.5 }]}
            disabled={item.disabled}
            onPress={() => {
              if (item.route) {
                navigation.navigate(item.route);
              } else if (item.link) {
                Linking.openURL(item.link);
              }
            }}
          >
            <Text style={styles.menuText}>{item.title}</Text>
            {item.disabled ? <Image source={require('./assets/Lock.png')} style={styles.arrow} /> : <Image source={require('./assets/next1.png')} style={styles.arrow} />}
          </TouchableOpacity>
        ))}

        <TouchableOpacity style={styles.menuItem} onPress={() => setModalVisible(true)}>
          <Text style={[styles.menuText, { color: 'red' }]}>Logout</Text>
        </TouchableOpacity>

        <Text style={styles.versionText}>v 1.0.0</Text>
      </ScrollView>

      {/* Logout Confirmation Modal */}
      <Modal
        animationType="slide"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => setModalVisible(false)}
      >
        <View style={styles.modalContainer}>
          <View style={styles.modalContent}>
            <Text style={styles.modalText}>Do you really want to logout?</Text>
            <View style={styles.modalButtons}>
              <TouchableOpacity style={styles.button} onPress={handleLogout}>
                <Text style={styles.buttonText}>Yes</Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.button} onPress={() => setModalVisible(false)}>
                <Text style={styles.buttonText}>No</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  header: {
    backgroundColor: '#A6CE39',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 16,
    paddingHorizontal: 20,
    position: 'relative',
  },
  headerTitle: {
    fontSize: 30,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
    fontWeight: 'bold',
    color: '#fff',
    left: '50%',
    transform: [{ translateX: -50 }],
  },
  notificationIcon: {
    width: 24,
    height: 28,
  },
  menuContainer: {
    paddingHorizontal: 16,
  },
  menuItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 14,
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  menuText: {
    fontSize: 18,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
    fontWeight: 'normal',
    color: '#333',
  },
  arrow: {
    width: 12,
    height: 18,
  },
  lock: {
    width: 20,
    height: 20
  },
  versionText: {
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
    fontWeight: 'normal',
    marginTop: 20,
    fontSize: 16,
    color: '#aaa',
  },
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  modalContent: {
    width: 300,
    padding: 20,
    backgroundColor: '#fff',
    borderRadius: 10,
    alignItems: 'center',
  },
  modalText: {
    fontSize: 18,
    marginBottom: 20,
  },
  modalButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  button: {
    flex: 1,
    padding: 10,
    marginHorizontal: 10,
    backgroundColor: '#A6CE39',
    alignItems: 'center',
    borderRadius: 5,
  },
  buttonText: {
    color: '#fff',
    fontSize: 16,
  },
});

export default ProfileScreen;
